import translationEN from '../../assets/locales/en/translation.json';
import translationFR from "../../assets/locales/fr/translation.json";
import translationPL from "../../assets/locales/pl/translation.json";

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { enqueueSnackbar } from 'notistack';
import {State} from '../../components/grid/BasicGridState'

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'flatpickr/dist/flatpickr.min.css';

import '../../components/grid/styles.scss';
import '../../components/grid/slickgrid.scss';
import '../../layouts/gridlayout.css'
import i18next, { TFunction } from 'i18next';

import ImportedMmailService from "../../services/email/imported.service";
import { ColorEditor } from '../../components/grid/CustomEditors/ColorEditor';




import {
   SlickgridReact, FieldType, Filters,
   GridOption,
  Column, Formatter, Formatters,
  Editors, EditCommand, 
  CompositeEditorModalType, OnCompositeEditorChangeEventArgs, CompositeEditorSelection,
  InputEditor,
  SlickGrid,
  OnAddNewRowEventArgs,
  EditorValidator,
  CurrentSorter,
  EmitterType,
} from 'slickgrid-react';

import { ExcelExportService } from '@slickgrid-universal/excel-export';
import { OdataOption, OdataServiceApi } from '@slickgrid-universal/odata';


import BaseGrid, {BasicGridProps} from '../../components/grid/BaseGridComponent';
import { TextOperators } from '../../components/grid/CustomFilters/TextFilter';
import { SlickCustomTooltip } from '@slickgrid-universal/custom-tooltip-plugin';
import authService from '../../services/auth/auth.service';
import { LookupCollection, LookupData } from '../../components/grid/GridUtils';

import { withTranslation } from 'react-i18next';
import { InputAdornment, TextField } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import BorderSpinner from '../../components/Layout/spinner';
import { parseHTML } from 'jquery';
import { FileEditor } from '../../components/grid/CustomEditors/FileEditor';

const ContrastColor = require('contrast-color');

const location = window.location
  
const locationley = location.pathname.replace('/', '')
const LOCAL_STORAGE_SEARCH = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-search' 

const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  pl: {
    translation: translationPL
  }
};


class ImportedMail extends BaseGrid {
  
    title = 'Masowa aktywacja/deaktywacja adresow pocztowych';
    subTitle = 'Zarządzanie aktywnością adresów pocztowych'

    addNewImport;
  
 constructor(public readonly props: BasicGridProps) {
    super(props);
    this.addNewImport = false;
    
 }




setSearchFilter() {
  if (this.reactGrid && localStorage[this.search_key] && localStorage[this.search_key]!==''){
    this.reactGrid.filterService.updateFilters([])

  }else{
    if (this.reactGrid){
       this.reactGrid.filterService.clearFilters()
    }
  }
}

  
onStorage = () => {
  this.setSearchFilter()
};
onFocus = () => {
  window.addEventListener("storage", this.onStorage)
};
onBlur = () => {
  window.removeEventListener("storage", this.onStorage)
};
  
componentDidMount() {
//    window.addEventListener("resize",((e: any) =>{
//      setTimeout(() => { this.reactGrid.resizerService.resizeGrid(); }, 1000);
      
//  }).bind(this));

  window.addEventListener("focus", this.onFocus);
  window.addEventListener("blur", this.onBlur);
  this.onFocus();
//this.defineGrid()

  this.getlookups();
    

    i18next.init({
      lng: 'pl',
      debug: false,
      resources: resources
    }, (err, t) => {
      i18next.changeLanguage("pl");
      
    });
  
}

 defineGrid() {
    var presets = JSON.parse(localStorage[this.storage_key] || null);

    if (presets){
      var new_sorters = presets.sorters.map((element: CurrentSorter) => {
        element.columnId = (element.columnId as string).toLowerCase();
        return element;
      });
      presets.sorters = new_sorters;
    }
   
    var gridOptions =  this.getGridDefinition();
    gridOptions.presets = presets

    var columnDefinitions = this.getColumnDefinitions();

    this.setState((state: State) => ({
      ...state,
      gridOptions:gridOptions,
      columnDefinitions:columnDefinitions,
    
  }));
}




userFormatter = function (row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
  var s=""
 
  if ( (dataContext.shortcut !=null)){  
        s=dataContext.shortcut 
        if ((dataContext.modifier_color !=null)){
       s=  '<a class="slickRowLink" href="/users">' +
          '<span style="backgroundColor:' + dataContext.modifier_color + '!important; color: ' + new ContrastColor(dataContext.modifier_color) + '" class="gavatar_m" >' + dataContext.shortcut +'</span>' + '</a>'
        }
      }
  return s;
};

componentDidUpdate(PrevProps: any, prevState: State){
  if(this.state.alertErrorMsg !== prevState.alertErrorMsg){
      if (this.state.alertErrorMsg){
        //alert(this.state.alertErrorMsg)
      }
  }   
  
}


  getGridDefinition(): GridOption {    
      var tmp = super.getGridDefinition(this.state);
      tmp = {
        ...tmp,
        enableTranslate: true,
        i18n: i18next,
        autoResize: {
          container: '#smaller-container',
          rightPadding: 10
        },
        enableRowSelection: true,
        enableExcelExport : true,
        excelExportOptions: {
          sanitizeDataExport: true
        },
        externalResources: [this.excelExportService, this.compositeEditorInstance, new SlickCustomTooltip()],
       
        editCommandHandler: (_item:any, _column:Column<any>, editCommand:EditCommand) => {
          var data = _item
          this._commandQueue.push(editCommand);
          editCommand.execute();
          
        },
        presets: {},
        
        backendServiceApi: {
          ...tmp.backendServiceApi,
          onError: (error: Error) => {
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: "Błąd połączenia!"
              }));  
          },
          preProcess: () => {
            this.setState((state: State) => ({ ...state, errorStatus: '' }));
            this.displaySpinner(true);
          },
          process: (query) => {
            if (localStorage[this.search_key] && localStorage[this.search_key]!=''){
              query=query + "&$search=" + localStorage[this.search_key].replace('&', 'i') 
            }
            return this.getImportedApiCall(query)},
          postProcess: (response) => {
            this.setState(
              (state: State) => ({ ...state, metrics: response.metrics }),
              () => this.postProcessCallback(response)
            );
            this.displaySpinner(false);
          },
        } as OdataServiceApi
      }
    return tmp;
  }

  onCellValidationError(_e: Event, args: any) {
    if (args.validationResults) {
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertWarning: args.validationResults.msg
      }));
    }
  }

  getlookups(){
      return ImportedMmailService.getlookups().then(response => {
         let tmp : LookupData[] = [];
          if ((response.data) && (Array.isArray(response.data) && (response.data[0].name=='status_name'))){
              let tmp1 :LookupCollection = response.data[0]
              this.setState((state: State) => ({
                ...state,
                lookupData : [tmp1]
              }),  () => this.defineGrid()
          
          );
        }
      }
         
      ).catch(
        () => {
          let tmp : LookupData[] = [];
          this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
          }));
          return tmp;
        }
      )
    }


  getColumnDefinitions(): Column[] {
    super.getColumnDefinitions()
    let tmp : Column[] = []; 

    let data_stats: LookupData[]  = [];

    this.state.lookupData?.forEach((item) => {
      if (item.name === 'status_name'){
        data_stats = item.data; 
      } 
      
      
    });

    if (authService.isAdmin()){
     
    }

    tmp.push(
      {
        id: 'row_no', name: 'Lp.', field: 'row_no', sortable: false, filterable: false,
        type: FieldType.integer,
        minWidth:30 ,
        maxWidth:50    
      },

     

        {
          id: 'comment', name: 'Komentarz', field: 'comment', sortable: true, filterable: true,
          excludeFromColumnPicker: true,
          type: FieldType.string,
          //formatter:this.taskTranslateFormatter,
          filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
          editor: {model: Editors.text,
            compositeEditorFormOrder : 1
          },
          hidden:false,
          minWidth:100   
        },
        {
          id: 'status_name', name: 'Status', field: 'status_name', sortable: true, filterable: true,
          type: FieldType.string,
          filter: {model: Filters.multipleSelect, collection:data_stats, compoundOperatorList: TextOperators},
          //editor: {model: Editors.singleSelect,
          //  collection: data_stats,
          //  compositeEditorFormOrder : 2,
          //  massUpdate: true,
          //},
          
          minWidth:100
        },

        {
          id: 'importedcount', name: 'Liczba zaimportowanych', field: 'importedcount', sortable: true, filterable: true,
          type: FieldType.integer,
          filter: {
            
          },
          minWidth:50
        },

        {
          id: 'processedcount', name: 'Liczba przetworzonych', field: 'processedcount', sortable: true, filterable: true,
          type: FieldType.integer,
          filter: {
            
          },
          minWidth:50
        },
        {
          id: 'changecount', name: 'Liczba zaktualizowanych rekordów', field: 'changecount', sortable: true, filterable: true,
          type: FieldType.integer,
          filter: {
            
          },
          minWidth:50
        },
        {
          id: 'unsubscribe', name: 'Email rezygnacja z NL', field: 'unsubscribe', sortable: true, filterable: true,
          type: FieldType.boolean,
          formatter: Formatters.checkmark,
          filter: {
            model: Filters.singleSelect,
            collection: [
              { value: '', label: '' },
              { value: 1, label: 'Tak' },
              { value: 0, label: 'Nie' },
            ],
          },
          editor: {model: Editors.checkbox,
            compositeEditorFormOrder : 3,
          },
          
          minWidth:50
        },

        {
          id: 'shortcut', name: 'Utworzony przez', field: 'shortcut', sortable: true, filterable: true,
          type: FieldType.string,
          cssClass: "column-centered",
          formatter:this.userFormatter,
          filter: {},           
          hidden:false,
          minWidth:50
               
        },

        {
          id: 'created', name: 'Data utworzenia', field: 'created', sortable: true, filterable: true,
          type: FieldType.dateTimeIso, // FieldType.string,
          formatter:Formatters.dateTimeIso,
          filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
          hidden:false,
          minWidth:100   
        },
        {
          id: 'modified', name: 'Data edycji', field: 'modified', sortable: true, filterable: true,
          type: FieldType.dateTimeIso, //FieldType.string,
          formatter:Formatters.dateTimeIso,
          filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
          hidden:false,
          minWidth:100   
        },

        {
          id: 'filepath', name: 'Plik', field: 'filepath', sortable: true, filterable: true,
          excludeFromColumnPicker: true,
          type: FieldType.string,
          //formatter:this.taskTranslateFormatter,
          filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
          editor: {model: FileEditor,
            compositeEditorFormOrder : 4
          },
          hidden:false,
          minWidth:100   
        },


       

    
    );
    tmp = this.customizeHeaderMenu(tmp)
    return tmp
  }



  getImportedApiCall(query: string) {
    return ImportedMmailService.getimportedmails(query)
  }
  

  sortCollectionDescending(collection: any[]) {
    return collection.sort((item1, item2) => item1.value - item2.value);
  }

  openCompositeModal(modalType: CompositeEditorModalType) {
    let modalTitle = '';
    if (this.reactGrid.slickGrid.getEditorLock().isActive() && !this.reactGrid.slickGrid.getEditorLock().commitCurrentEdit()) {
      return;
    }
      switch (modalType) {
        case 'create':
          modalTitle = 'Import nowej listy';
          this.addNewImport = true
          break;
        case 'clone':
          modalTitle = 'Import listy maili}';
          this.addNewImport = false
          break;
        case 'edit':
          this.addNewImport = false
          var selecttedcount =  this.reactGrid.slickGrid.getSelectedRows();
          if (selecttedcount.length > 1){
            modalTitle = 'Edycja wybranych rekordów (' + selecttedcount + ')';
            modalType = 'mass-selection';
          }else{
            this.addNewImport = false
            modalTitle = 'Edycja importu'; // 'Editing - {{title}} ({{product.itemName}})'
          }
          break;
      }
      var modalColumns = this.reactGrid.slickGrid.getColumns(). filter(col => col.editor);

    if (modalType==='edit'){
      if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length===1)){
        this.compositeEditorInstance?.openDetails({
          headerTitle: modalTitle,
          modalType,
          insertOptions: { highlightRow: false }, 
          showFormResetButton: true,
          resetFormButtonIconCssClass: 'fa fa-undo',
          
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
        });
      }else if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length>1)){
        alert('Wybież jeden import do edycji!');
      }else{
        alert('Nie wybrano importu do edycji!');
      }
    }else{
        this.compositeEditorInstance?.openDetails({
            headerTitle: modalTitle,
            modalType,
            insertOptions: { highlightRow: false }, 
            showFormResetButton: true,
            resetFormButtonIconCssClass: 'fa fa-undo',
          
            
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => console.log(error.message),
          onSave: async (formValues, _selection: CompositeEditorSelection, dataContext) => {
            let tmp = {...dataContext, id:null}
            let filedata = await tmp.file
            delete tmp.file;
            tmp.filedata = filedata;
            console.log('FFFFFF')
            console.log(tmp)
            console.log('GGGGG')
            console.log(formValues)
            this.addNewImport = false; 
            
            ImportedMmailService.addimport(tmp).then(
                (data) => {
                      //this.reactGrid.filterService.updateFilters([])
                      this.reactGrid.slickGrid.invalidate()
                      window.location.reload()   
                                //console.log(data)
                    }
                ).catch(
                  (error) => {
                    try{   
                      console.log(error)
                      if (error && error.response && error.response.data && error.response.data.detail){
                        this.setState((state, props) => ({
                          ...state,
                          alertError: "Błąd: " + error.response.data.detail
                        }));
                      }else{          
                        this.setState((state, props) => ({
                          ...state,
                          alertError: "Błąd podczas dodawania kontrahenta"
                        }));
                      }
                      
                      var tmp = this.reactGrid.slickGrid.getData().getItems()
                      tmp.splice(0,1);
                      
                      this.reactGrid.slickGrid.getData().setItems(tmp)
                    }catch{
          
                    }
                  }
                )   
                   
            
           
            const serverResponseDelay = 50;
            return new Promise(resolve => setTimeout(() => resolve(true), serverResponseDelay));
        }
      });
    }
  }
    
  onCellClicked(_e: Event, args: any) {
    this.addNewImport = false;
    const metadata = this.reactGrid.gridService.getColumnFromEventArguments(args);

    if (metadata.columnDef.id === 'delete') {
      
      if (window.confirm('Czy potwierdzasz usunięcie importu: ' + metadata.dataContext.label + '?')) {
        /*FairService.deletefair(metadata.dataContext.id).then(
          () => {
            this.reactGrid.gridService.deleteItemById(metadata.dataContext.id)

            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertInfo: `Usunięto: ${metadata.dataContext.label}`,
            }));
        }

        ).catch(
          () => {
            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: `Wystąpił problem przy usuwaniu etykiety: ${metadata.dataContext.label}`,
            }));
          }
        )
        */
        
      }
    }
  }

  checkItemIsEditable(dataContext: any, columnDef: Column, grid: SlickGrid) {

    return this.addNewImport;
  }

  handleonAddNewRow(_e: Event, args: OnAddNewRowEventArgs) {
     //return false;
  }

  handleOnCompositeEditorChange(_e: Event, args: OnCompositeEditorChangeEventArgs) {
   
  }

  handleOnBeforeEditCell(e: Event, args: any) {
    const { column, item, grid } = args;

    if (column && item && !this.checkItemIsEditable(item, column, grid)) {
      e.stopImmediatePropagation();
      return false;
    }
    return true;
  }

  resizeContent($event:any){
 
  }

  render() {
    if (this.state.alertWarning) {
      enqueueSnackbar(this.state.alertWarning, {variant: 'warning', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertWarning: ''
      }));
    }
    if (this.state.alertError) {
      enqueueSnackbar(this.state.alertError, {variant: 'error', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertError: ''
      }));
    }

    if (this.state.alertInfo) {
      enqueueSnackbar(this.state.alertInfo, {variant: 'info', preventDuplicate: true, autoHideDuration:5000, persist: false}) 
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertInfo: ''
      }));
    }

    return !this.state.gridOptions ? '' : (
       <>
          <div className="gridMenu">
            <div className='gridLeftSubMenu'> 
             <FormControlLabel id="lblautoedit" control={<Switch checked={this.state.isAutoEdit} onChange={(_, data) => this.autoeditchange(data)}  />} label="Auto-edit" />

              
            </div>
            
            
            <div className='gridCenterSubMenu'>
            
            { <button className="btn btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                  onClick={() => {this.openCompositeModal('create')} 
            }>
                  Import
                </button>
            }

            
          
        
            </div><div className='gridRightSubMenu'>
                <button className="btn btn-outline-secondary btn-sm mx-1" data-test="set-dynamic-sorting"
                  onClick={() => this.setFactorySettings()}>
                  Ustawienia domyślne
                </button>

              </div>
          </div>
          <div id="smaller-container" onResize={this.resizeContent} style={{ width: '100%' }}>
          {this.state.status.text =='loading' ? <BorderSpinner/> : ''}
          
          <SlickgridReact gridId="importunsubscribemail-grid"
            columnDefinitions={this.state.columnDefinitions}
            gridOptions={this.state.gridOptions}
            dataset={this.state.dataset}
            paginationOptions={this.state.paginationOptions}
            onReactGridCreated={$event => this.reactGridReady($event.detail)}
            onGridStateChanged={$event => this.gridStateChanged($event.detail)}
            onClick={e => { this.onCellClicked(e.detail.eventData, e.detail.args); }}  
            onBeforeEditCell={$event => this.handleOnBeforeEditCell($event.detail.eventData, $event.detail.args)}   
            onCompositeEditorChange={$event => this.handleOnCompositeEditorChange($event.detail.eventData, $event.detail.args)}
            onAddNewRow={$event => this.handleonAddNewRow($event.detail.eventData, $event.detail.args)}
            onValidationError={e => { this.onCellValidationError(e.detail.eventData, e.detail.args); }}
            
            
          />
          </div>
      </>
    );
  }
}

export default withTranslation()(ImportedMail);